import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import Home from "./Home/Home";
import Contact from "./Home/Contact";
import PrivacyPolicy from "./Home/PrivacyPolicy";

import Course from "./Courses/Course";
import Profiles from "./Courses/Profiles";
import CourseContent from "./Courses/CourseContent";

import Trainee from "./Trainee/Trainee";
import TraineeSignUp from "./Trainee/TraineeSignup";
import TraineeSignIn from "./Trainee/TraineeSignIn";
import TraineeDetails from "./Trainee/TraineeDetails";
import TraineeAddress from "./Trainee/TraineeAddress";
import TraineeEducation from "./Trainee/TraineeEducation";
import TraineeCertification from "./Trainee/TraineeCertification";
import TraineeSkill from "./Trainee/TraineeSkill";
import TraineeSocialLink from "./Trainee/TraineeSocialLink";
import TraineeCareerPreference from "./Trainee/TraineeCareerPreference";
import TraineeCareerMatches from "./Trainee/TraineeCareerMatches";
import TraineeSaved from "./Trainee/TraineeSaved";
import MyCourseMaterial from "./Trainee/MyCourseMaterial";
import TraineeProfile from "./Trainee/TraineeProfile";
import {
  TraineeEnrollmentsPage,
  TraineeInternshipApplicationsPage,
  TraineeJobApplicationsPage,
} from "./Trainee/TraineeListPages";

import Trainer from "./Trainer/Trainer";
import TrainerSignIn from "./Trainer/TrainerSignIn";
import TrainerDashboard from "./Trainer/TrainerDashBoard";
import TrainerDetails from "./Trainer/TrainerDetails";
import TrainerAddress from "./Trainer/TrainerAddress";
import TrainerEducation from "./Trainer/TrainerEducation";
import TrainerCertification from "./Trainer/TrainerCertification";
import TrainerWorkExperience from "./Trainer/TrainerExperience";
import TrainerAchievements from "./Trainer/TrainerAchievements";
import TrainerSocialLink from "./Trainer/TrainerSocialLinks";
import MyProfile from "./Trainer/MyProfiles";
import TrainerProfile from "./Trainer/TrainerProfile";
import TrainerCourseMaterial from "./Trainer/TrainerCourseMaterial";
import CourseDetails from "./Trainer/CourseDetails";
import TrainerEnrollments from "./Trainer/TrainerEnrollments";
import AddTrainerBatches from "./Trainer/AddTrainerBatches";
import AddTopics from "./Trainer/AddTopics";
import CourseSubTopics from "./Trainer/CourseSubTopics";
import AddSubTopic from "./Trainer/AddSubTopic";
import DetailsOfTrainer from "./Trainer/DetailsOfTrainer";
import DetailsOfUser from "./Company/DetailsOfUser";

import Company from "./Company/Company";
import EmployerSignIn from "./Company/EmployerSignIn";
import EmployerDetails from "./Company/EmployerDetails";
import UserSignUp from "./Company/UserSignUp";
import UserSignIn from "./Company/UserSignIn";
import ForgotPassword from "./Company/ForgotPassword";
import ChangePassword from "./Company/ChangePassword";
import CompanyDetails from "./Company/CompanyDetails";
import AddCompany from "./Company/AddCompany";
import CompanyProfile from "./Company/CompanyProfile";
import CompanyAddress from "./Company/CompanyAddress";
import AddUser from "./Company/AddUser";
import UserProfilePage from "./Company/MultipleProfiles";
import UserProfile from "./Company/UserProfile";
import UserDashboard from "./Company/UserDashboard";
import ProfileDetails from "./Company/ProfileDetails";
import UserCourseMaterial from "./Company/UserCourseMaterial";
import CourseMaterial from "./Company/CourseMaterial";
import Enrollments from "./Company/Enrollments";
import AddBatch from "./Company/AddBatches";
import AddTopic from "./Company/AddTopic";
import AddSubTopics from "./Company/AddSubTopics";
import SubTopics from "./Company/SubTopics";
import Profile from "./Company/Profile";
import UpdateProfile from "./Company/UpdateProfile";
import UserAddress from "./Company/UserAddress";
import UserEducation from "./Company/UserEducation";
import UserCertifications from "./Company/UserCertifications";
import UserWorkExperience from "./Company/UserExperience";
import UserAchievements from "./Company/UserAchievements";
import UserSocialLink from "./Company/UserSocialLink";
import AddInternship from "./Company/AddInternship";
import AddJob from "./Company/AddJob";
import Applications from "./Company/Applications";
import JobApplications from "./Company/JobApplications";

import Internship from "./Internships/Internship";
import InternshipDetails from "./Internships/InternshipDetails";
import Job from "./Jobs/Job";
import JobDetails from "./Jobs/JobDetails";

import Institution from "./Institution/Institution";
import InstitutionSignIn from "./Institution/InstitutionSignIn";
import InstitutionDetails from "./Institution/InstitutionDetails";

const BASENAME = process.env.REACT_APP_BASE_PATH || "/als";
function App() {

  return (
    <Router basename={BASENAME}>
      <Routes>
        {/* Define routes */}
        {/* <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} /> */}
         <Route path="/" element={<Home />} />
        {/* <Route path="/" element={<Navigate to="/courses" replace />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/courses" element={<Course />} />
        <Route path="/profiles/:profileId" element={<Profiles />} />
        <Route path="/courses/:batchId" element= {<CourseContent/>} />

        <Route path="/internships" element={<Internship />} />
        <Route path="/internships/:id" element={<InternshipDetails />} />
        <Route path="/jobs" element={<Job />} />
        <Route path="/jobs/:id" element={<JobDetails />} />

        <Route path="/trainee" element={<Trainee />} />
        <Route path="/trainee-signup" element={<TraineeSignUp />} />
        <Route path="/trainee-signin" element={<TraineeSignIn />} /> 
        <Route path="/trainee-profile" element={<TraineeProfile />} /> 
        <Route path="/my-enrollments" element={<TraineeEnrollmentsPage />} />
        <Route
          path="/my-internship-applications"
          element={<TraineeInternshipApplicationsPage />}
        />
        <Route
          path="/my-job-applications"
          element={<TraineeJobApplicationsPage />}
        />
        <Route path="/trainee-details" element={<TraineeDetails />} />
        <Route path="/trainee-address" element={<TraineeAddress />} /> 
        <Route path="/trainee-education" element={<TraineeEducation/>} /> 
        <Route path="/trainee-certification" element={<TraineeCertification/>} /> 
        <Route path="/trainee-skill" element={<TraineeSkill/>} />
        <Route path="/trainee-social-link" element={<TraineeSocialLink/>} />
        <Route path="/trainee-career-preference" element={<TraineeCareerPreference/>} />
        <Route path="/matched-opportunities" element={<TraineeCareerMatches/>} />
        <Route path="/my-saved" element={<TraineeSaved />} />
        <Route path="/my-courses/material/:batchId" element={<MyCourseMaterial />} />

        <Route path="/trainers" element={<Trainer />} />
        <Route path="/trainer-signin" element={<TrainerSignIn />} />
        <Route path="/trainer-profile" element={<TrainerDashboard />} />
        <Route path="/trainer-details" element={<TrainerDetails />} />
        <Route path="/trainer/:trainerId" element={<DetailsOfTrainer />} />
        <Route path="/user/:userId" element={<DetailsOfUser />} />
        <Route path="/trainer-address" element={<TrainerAddress />} /> 
        <Route path="/trainer-education" element={<TrainerEducation/>} /> 
        <Route path="/trainer-certification" element={<TrainerCertification/>} /> 
        <Route path="/trainer-experience" element={<TrainerWorkExperience/>} />
        <Route path="/trainer-achievement" element={<TrainerAchievements/>} /> 
        <Route path="/trainer-social-link" element={<TrainerSocialLink/>} /> 
        <Route path="/my-profiles" element={<MyProfile />} /> 
        <Route path="/trainer-profile/:profileId" element={<TrainerProfile />} />
        <Route path="/trainer-course-materials" element={<TrainerCourseMaterial />} />
        <Route path="/course-details/:courseMaterialId" element={<CourseDetails />} />
        <Route path="/trainer-enrollments/:batchId" element={<TrainerEnrollments />} />
        <Route path="/course-batch" element={<AddTrainerBatches/>} /> 
        <Route path="/course-topic" element={<AddTopics />} />
        <Route path="/course-sub-topics/:topic_id" element={<CourseSubTopics />} /> 
        <Route path="/sub-topic" element={<AddSubTopic />} /> 

        <Route path="/employers" element={<Company />} />
        <Route path="/employer-signin" element={<EmployerSignIn />} />
        <Route path="/employer/:companyId" element={<EmployerDetails />} />
        <Route path="/UserSignup" element={<UserSignUp />} />
        <Route path="/UserSignin" element={<UserSignIn />} /> 
        <Route path="/forgot-password" element={<ForgotPassword/>} /> 
        <Route path="/change-password" element={<ChangePassword/>} /> 
        <Route path="/company-details" element={<CompanyDetails />} /> 
        <Route path="/add-company" element={<AddCompany />} />  
        <Route path="/company-profile/:company_id" element={<CompanyProfile />} />
        <Route path="/add-address" element={<CompanyAddress />} /> 
        <Route path="/add-user" element={<AddUser />} />   
        <Route path="/company/user-profiles/:userId" element={<UserProfilePage />} />
        <Route path="/user-profile" element={<UserDashboard/>} />
        <Route path="/my-profile" element={<UserProfile/>} />
        <Route path="/profile/:profileId" element={<ProfileDetails />} />
        <Route path="/user-course-materials" element={<UserCourseMaterial />} /> 
        <Route path="/course-material/:courseMaterialId" element={<CourseMaterial />} />
        <Route path="/enrollment/:batchId" element={<Enrollments />} />
        <Route path="/user-batch" element={<AddBatch />} /> 
        <Route path="/user-topic" element={<AddTopic />} /> 
        <Route path="/sub-topics" element={<AddSubTopics />} /> 
        <Route path="/sub-topics/:topic_id" element={<SubTopics />} /> 
        <Route path="/my-details" element={<Profile />} />
        <Route path="/updateprofile" element={<UpdateProfile/>}/> 
        <Route path="/user-address" element={<UserAddress />} /> 
        <Route path="/user-educations" element={<UserEducation />} /> 
        <Route path="/user-certifications" element={<UserCertifications />} /> 
        <Route path="/user-workExperiences" element={<UserWorkExperience />} /> 
        <Route path="/user-achievements" element={<UserAchievements/>} /> 
        <Route path="/user-socialLinks" element={<UserSocialLink/>} /> 
        <Route path="/add-internship" element={<AddInternship />} /> 
        <Route path="/user-internship/:internship_id" element={<Applications />} /> 
        <Route path="/add-job" element={<AddJob />} />
        <Route path="/user-job/:job_id" element={<JobApplications />} /> 

        <Route path="/institutions" element={<Institution />} />
        <Route path="/institution-signin" element={<InstitutionSignIn />} />
        <Route path="/institution/:companyId" element={<InstitutionDetails />} />
        <Route path="/institution-details" element={<CompanyDetails />} /> 
        <Route path="/add-institution" element={<AddCompany />} />  
        <Route path="/institution-profile/:company_id" element={<CompanyProfile />} />
        <Route path="/institution/user-profiles/:userId" element={<UserProfilePage />} />
      </Routes>
    </Router>
  );
}

export default App;


